// import 'scroll-polyfill/auto';

// // OR:
// import scrollPolyfill from 'scroll-polyfill';

// scrollPolyfill();

// または、ポリフィルを強制することができます（スキップ機能の検出）
// // or you can force the polyfill (skiping feature detection)
// scrollPolyfill({ force: true });

// // use ScrollToOptions
// window.scroll({ behavior: 'smooth', left: 100, top: 100 });
// scroller.scrollBy({ behavior: 'smooth', top: 100 });

// // use ScrollIntoViewOptions
// scrollerChild.scrollIntoView({
//   behavior: 'smooth',
//   block: 'nearest',
//   inline: 'start',
// });
// document.body.scrollIntoView(false);

export class ScrollObserver {
  constructor(els, cb, options) {
    this.els = document.querySelectorAll(els);
    const defaultOptions = {
      root: null,
      rootMargin: '-200px 0px',
      threshold: 0,
      once: true,
    };
    this.cb = cb;
    this.options = Object.assign(defaultOptions, options);
    this.once = this.options.once;
    this._init();
  }
  _init() {
    const callback = function (entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.cb(entry.target, true);
          if (this.once) {
            observer.unobserve(entry.target);
          }
        } else {
          this.cb(entry.target, false);
        }
      });
    };

    this.io = new IntersectionObserver(callback.bind(this), this.options);

    // @see https://github.com/w3c/IntersectionObserver/tree/master/polyfill
    this.io.POLL_INTERVAL = 100;

    this.els.forEach((el) => this.io.observe(el));
  }

  destory() {
    this.io.disconnect();
  }
}
